import React from "react";
import Row from "../../../common/Row";
import PropTypes from "prop-types";
import Table from "../../../common/Table";
import moment from "moment";

const KopieerTochtGegevensComponent = props => {
	const {
		onSelectTocht,
		tochten,
		tochtTypes,
		fetchedKopieerbareTochten
	} = props;

	const title = <b>Overnemen algemene gegevens van andere tocht</b>;

	const headers = ["Kopieer", "Datum", "Tocht", "Startgemeente", "Soort tocht"];
	const headerSizes = [10, 13, 30, 22, 25];
	const getTochtTypeNaam = tochtTypeId => {
		const tochtType = tochtTypes.find(t => t.value === tochtTypeId);
		return tochtType ? tochtType.label : "";
	};
	const createRows = () =>{
		return tochten && tochten.map(row =>{
			return (<tr key={row.id}>
				<td className="center-text interactable"><i onClick={() => onSelectTocht(row.id)} className="fa fa-copy"></i></td>
				<td>{moment(row.datum).format("DD/MM/YYYY")}</td>
				<td>{row.naam}</td>
				<td>{row.startGemeente}</td>
				<td>{getTochtTypeNaam(row.tochtTypeId)}</td>
			</tr>);
		});
	};

	const tableStyle = { height: '440px', overflow: 'auto' };

	if(!fetchedKopieerbareTochten)
		return <div>{title}<Row>Tochten aan het ophalen... Dit kan enkele minuten duren.</Row></div>;

	return (
		tochten && tochten.length > 0 ?
		<div>
			{title}
			<div>Selecteer hieronder in het overzicht een reeds aangemaakte tocht om de gegevens van de organisator en de startlocatie te kopiëren. Het soort tocht en de afstanden/routes met de respectievelijke GPX-en worden niet gekopieerd.</div>
			<Row>
				<div style={tableStyle}>
					<Table headers={headers} headerSizes={headerSizes}>
						{createRows()}
					</Table>
				</div>
			</Row>
		</div> :
		<div>
			{title}
			<Row>Er zijn nog geen tochten aangemaakt.</Row>
		</div>
	);
};

KopieerTochtGegevensComponent.propTypes = {
	onSelectTocht:PropTypes.func.isRequired,
	tochten: PropTypes.array.isRequired,
	tochtTypes: PropTypes.array.isRequired,
	fetchedKopieerbareTochten: PropTypes.bool.isRequired
};

export default KopieerTochtGegevensComponent;
